export default {
  MuiMenuItem: {
    root: {
      padding: [6, 16],
      fontSize: 12,
      lineHeight: 1.3,
    },
  },
};
